<script setup>
import { onBeforeUnmount, onMounted } from 'vue'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import AppAvailable from '@/components/pages/home/AppAvailable.vue'
import ChooseUs from '@/components/pages/home/ChooseUs.vue'
import HotelEarn from '@/components/pages/home/HotelEarn.vue'
import HotelFeatured from '@/components/pages/home/HotelFeatured.vue'
import CountryHot from '@/components/pages/home/CountryHot.vue'
import MainBanner from '@/components/pages/home/MainBanner.vue'
import TestiUsers from '@/components/pages/home/TestiUsers.vue'
import { bannerModel } from '@/model/basic'
import { countryModel, hotelModel } from '@/model/task'
import { userModel } from '@/model/user'
const { countryListRef } = countryModel()
const { hotelListRef } = hotelModel()
const { currentLevel } = userModel()

const { bannerListRef, bannerIndex, startFunc, clearFunc } = bannerModel()

onMounted(()=> {
  startFunc()
})
onBeforeUnmount(()=> {
  clearFunc()
})
</script>

<template>
  <div class=" overflow-hidden">
    <!-- banner -->
    <MainBanner :bannerListRef="bannerListRef" :bannerIndex="bannerIndex" />
    <!-- hot hotel -->
    <CountryHot :list="countryListRef" />
    <!-- earn hotel -->
    <HotelEarn :list="hotelListRef" :currentLevel="currentLevel" />
    <!-- Featured hotel -->
    <HotelFeatured :list="hotelListRef" :currentLevel="currentLevel" />
    <!-- choose us -->
    <ChooseUs />
    <!-- app -->
    <AppAvailable />
    <!-- Testimonials -->
    <TestiUsers />

    <!-- bottom -->
    <section class="py-[110px] bg-center relative" :style="'background-image: url('+require('@/assets/img/bg-bottom.jpeg')+')'" style="background-size: 100% auto;">
      <em class="w-full h-full bg-black/40 absolute left-0 top-0"></em>
    </section>
  </div>
</template>
<style>

</style>